// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"5321cb2f","833":"96b9cdf0"}[chunkId] + ".chunk.js";
};